import React from 'react';
import { CTAButton } from './Shared';
export const FinalCtaSection = () => {
  return <section className="bg-familia-bg border-t border-familia-electric/30 py-10 md:py-16 px-4 md:px-6" data-id="element-78">
      <div className="max-w-3xl mx-auto text-center w-[92%] md:w-full" data-id="element-79">
        <h2 className="text-white font-display font-extrabold text-2xl sm:text-3xl md:text-4xl mb-3 leading-tight" data-id="element-80">
          Dale a tu aula una misión mundialista
        </h2>
        <p className="text-familia-cyan font-bold text-sm sm:text-base mb-8" data-id="element-81">
          Planificación, actividades, evaluación y cuatro bonos listos para
          descargar.
        </p>

        <div className="bg-familia-section border-2 border-familia-gold rounded-2xl p-6 sm:p-8 shadow-[0_0_30px_-12px_rgba(215,168,62,0.5)] mb-8" data-id="element-82">
          <div className="flex flex-col items-center mb-6" data-id="element-83">
            <span className="text-familia-red line-through text-lg mb-1 font-bold" data-id="element-84">
              Antes: USD 24
            </span>
            <span className="text-familia-green text-4xl sm:text-5xl font-display font-bold mb-2" data-id="element-85">
              HOY: USD 12
            </span>
            <span className="bg-familia-electric text-white text-xs font-bold px-3 py-1 rounded-full uppercase" data-id="element-86">
              50% DE DESCUENTO
            </span>
            <span className="text-familia-gray text-[11px] font-semibold uppercase tracking-wider mt-2" data-id="element-87">
              Precio sin impuestos
            </span>
          </div>

          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-left mb-6" data-id="element-88">
            {['De 1.º a 7.º grado', 'Cuatro bonos incluidos', 'Acceso inmediato', 'Garantía de 7 días'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-89">
                <span className="text-familia-green text-sm shrink-0" data-id="element-90">✅</span>
                <span className="text-xs sm:text-sm font-medium text-white/90" data-id="element-91">
                  {item}
                </span>
              </div>)}
          </div>

          <CTAButton href="https://mundial-en-el-aula-megapack-primaria.impultienda.ar/checkout" className="w-full text-base sm:text-lg py-4" data-id="element-92">
            QUIERO EL MEGA PACK POR USD 12
          </CTAButton>

          <p className="text-familia-gray text-[10px] leading-relaxed text-center mt-4" data-id="element-93">
            En el checkout, el importe se convierte a tu moneda local. El total
            puede variar según impuestos, tipo de cambio y condiciones de tu
            medio de pago.
          </p>
        </div>

        <p className="text-familia-gray text-xs font-medium" data-id="element-94">
          Pago único · Sin suscripciones · Acceso de por vida · Disponible en
          toda Latinoamérica.
        </p>
      </div>
    </section>;
};